<button
  class="button button--filter"
  data-controller="generic/ui/ContentOpener"
  data-config='{"type": "OverlayReturn", "contentId": "filterOne", "break": "ml", "fullHeight": true, "siblingId": "filterSibling"}'
  title=""
>
  {{ FILTER_BUTTON_LABEL }}
</button>
